import { Component, Input } from '@angular/core';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { EnumPageDisplayModes, EnumPageEntitySources, EnumWindowSizes } from '@core/framework/sysenums.enum';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

class State extends BaseState {
    ImageSource: string | SafeUrl;
}
@Component({
    providers: ServiceBagServices,
    selector: 'm4u-imageboxdialog',
    templateUrl: './imageboxdialog.component.html',
    styleUrls: ['./imageboxdialog.component.scss']
})
export class ImageBoxDialogComponent extends BasePageComponent<BaseEntity, State>
{
    @Input() set ImageSource(value: string | Blob) {
        this.State.ImageSource = typeof value === 'string' ? value : this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(value));
    }
    @Input() Title: string;
    @Input() ShowLargeWindow: boolean = false;
    
    WindowHeight: EnumWindowSizes = EnumWindowSizes.WindowLarge;
    WindowWidth: EnumWindowSizes = EnumWindowSizes.WindowMedium;

    constructor(A: ServiceBagService, private sanitizer: DomSanitizer)
    {
        super(A, 'ImageBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    // If custom title was set, return it
    override OnInitTitle(): string
    {
        if (this.Title == undefined) return this.GetDefaultTitle();
        return this.GetDefaultTitle() + ' - ' + this.Title;
    }

    override OnInitComponent() {
        if (this.ShowLargeWindow) {
            this.WindowHeight = this.WindowWidth = EnumWindowSizes.WindowXLarge;
        }
    }
}
